<template>
    <f7-page
        name="Help"
        class="onboardingBg"
    >
        <f7-navbar
            large
            large-transparent
            title-large="Help"
            inner-class="onboardingBg"
        >
            <f7-nav-left>
                <f7-link
                    back
                    icon="ion-ios-arrow-left"
                />
            </f7-nav-left>
            <f7-nav-title>Help</f7-nav-title>
        </f7-navbar>
        <f7-block-title class="blockTitle">What can we do for you today?</f7-block-title>
        <f7-list style="margin-top: 0">
            <f7-list-item
                :smart-select-params="{openIn: 'popover', routableModals: false, closeOnSelect: true}"
                title="I need help with..."
                smart-select
            >
                <select
                    name="reason"
                    @change="changeReason"
                >
                    <option v-if="!reasonSelected" />
                    <option
                        v-for="(reason, index) in reasons"
                        :value="index"
                        :key="`reason-${index}`"
                    >{{ reason.name }}</option>
                </select>
            </f7-list-item>

        </f7-list>
        <template v-if="reasonSelected">
            <template v-if="items.length">
                <f7-block-title class="blockTitle">F.A.Q.</f7-block-title>
                <f7-list>
                    <f7-list-item
                        v-for="(item, index) in items"
                        :title="item.question"
                        :key="`faqs-${index}`"
                        accordion-item
                        @accordion:opened="openFAQ(item)"
                    >
                        <f7-accordion-content>
                            <f7-block
                                class="foldedBlock"
                                v-html="item.answer"
                            />
                        </f7-accordion-content>
                    </f7-list-item>

                    <f7-list-item link="/faq">
                        All questions
                    </f7-list-item>
                </f7-list>
            </template>
            <f7-block-title class="blockTitle">Still need help? Contact us!</f7-block-title>
            <f7-list style="background: white; color: black">
                <f7-list-input
                    :value="user.name || ''"
                    label="Your name"
                    type="email"
                    placeholder=""
                    clear-button
                    @input="ticket.name=$event.target.value"
                />
                <f7-list-input
                    :value="user.email || ''"
                    label="Your email"
                    type="email"
                    placeholder="your@email.com"
                    clear-button
                    @input="ticket.email=$event.target.value"
                />
                <f7-list-input
                    :value="ticket.title || ''"
                    label="Subject"
                    type="text"
                    placeholder="I need help with..."
                    clear-button
                    @input="ticket.title=$event.target.value"
                />
                <f7-list-input
                    :value="ticket.message || ''"
                    label="Message"
                    type="textarea"
                    resizable
                    placeholder=""
                    clear-button
                    style="min-height: 88px"
                    @input="ticket.message=$event.target.value"
                />
            </f7-list>
            <f7-block style="margin-top: 32px">

                <div class="ansButtons ">
                    <f7-button
                        color="red"
                        fill
                        round
                        @click="submitTicket"
                    >Submit</f7-button>

                </div>
            </f7-block>
        </template>
    </f7-page>
</template>
 

<script>
import faqs from '../../js/faq';

export default {
    store: ['api', 'user'],
    data () {
        return {
            ticket: {
                name: '',
                email: '',
                title: '',
                message: '',
                reason: '',
                smartUrl: '',
            },
            reason: {
                type: '',
                name: '',
            },
            reasonSelected: false,
            reasons: [
                {
                    type: 'billing',
                    name: 'Billing',
                    subject: 'I have a billing issue',
                }, {
                    type: 'partner',
                    name: 'Partner features',
                    subject: 'I need help with our accounts',
                }, {
                    type: 'data',
                    name: 'Privacy',
                    subject: 'I have a data/privacy issue',
                }, {
                    type: 'communication',
                    name: 'Notifications',
                    subject: 'I have an issue with notifications',
                }, {
                    type: 'bug',
                    name: 'Report a problem',
                    subject: 'I have experienced a problem',
                }, {
                    type: 'other',
                    name: 'Other',
                    subject: ''
                }
            ],
            items: [],
        };
    },
    computed: {
        device: function () {
            return f7.device;
        }
    },
    created: function () { },
    mounted: function () {
        this.ticket.email = this.user.email || '';
        this.ticket.name = this.user.name || '';
    },
    methods: {
        openFAQ: function (item) {
            this.$events.fire('trackEvent', 'support_faq_opened', 'faq', 0, item.question, {
                reason: item.section,
                question: item.question,
            });
        },
        submitTicket: function () {
            f7.preloader.show();
            if (pgap && cordova.plugins && cordova.plugins.SmartlookPlugin) {
                cordova.plugins.SmartlookPlugin.getDashboardSessionUrl((url) => {
                    // success
                    this.ticket.smartUrl = url;
                    this.createTicket();
                }, () => {
                    // error
                    this.createTicket();
                });
            } else {
                this.createTicket();
            }
        },
        createTicket: function () {
            this.$http.post(`${this.api}/support`, this.ticket).then(
                response => {
                    f7.preloader.hide();
                    if (response.body) {
                        console.log(response.body);
                        f7.dialog.alert('Help is on the way! We’ve received your message and will be in touch shortly.');
                        this.reasonSelected = false;
                        this.ticket.title = '';
                        this.ticket.message = '';
                        this.ticket.reason = '';

                    }
                },
                response => {
                    f7.preloader.hide();
                    f7.dialog.alert(response.body.message);
                });
        },
        changeReason: function (e) {
            f7.preloader.hide();
            this.reasonSelected = true;
            this.reason = this.reasons[parseFloat(e.target.value)];
            this.ticket.reason = this.reason.type;
            this.ticket.title = this.reason.subject;
            let faqType = this.reason.type;
            if (['bug', 'other'].indexOf(faqType) > -1) faqType = 'default';
            this.items = [];
            for (let i = 0; i < faqs.length; i++) {
                const faq = faqs[i];
                if (faq.types.indexOf(faqType) > -1) {
                    this.items.push(faq);
                }
            }
        },
        openFeedback: function () {
            if (pgap) {
                cordova.plugins.email.open({
                    to: 'support@getcoral.app',
                    subject: 'Coral Feedback',
                    body: 'Please mention what browser or phone your are using. Thank you!',
                    isHtml: true
                });
            } else {
                window.open(
                    'mailto:support@getcoral.app?subject=' +
                    'Coral Feedback' +
                    '&body=' +
                    'Please mention what browser or phone your are using. Thank you!'
                );
            }
        }
    }
};
</script>

<style lang="less" scoped>
.blockTitle {
    text-transform: uppercase;
    font-family: AndesMedium;
    font-style: normal;
    font-weight: 300;
    font-size: 15px;
    line-height: 22px;
}
.foldedBlock {
    text-align: left;
    font-family: 'Andes';
    font-size: 15px;
    letter-spacing: normal;
    font-weight: normal;
    padding-bottom: 40px;
}
.center {
    text-align: center;
}
</style>
